// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module--container--3eWCO","row":"styles-module--row--eTKup","block":"styles-module--block--1Gc8v","inline_block":"styles-module--inline_block--2JNHm"};